var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mdl-layout mdl-js-layout mdl-layout--fixed-header" },
    [
      _c("header", { staticClass: "mdl-layout__header" }, [
        _vm.user ? _c("div", { staticClass: "mdl-layout-icon" }) : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "mdl-layout__header-row" }, [
          _c("span", { staticClass: "mdl-layout__title" }, [
            _vm._v("Brunch Map")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mdl-layout-spacer" }),
          _vm._v(" "),
          _c("nav", { staticClass: "mdl-navigation" }, [
            _vm.user
              ? _c(
                  "a",
                  {
                    staticClass: "mdl-navigation__link",
                    attrs: { href: "#" },
                    on: { click: _vm.unauth }
                  },
                  [_vm._v("Logout")]
                )
              : _c(
                  "a",
                  {
                    staticClass: "mdl-navigation__link",
                    attrs: { href: "#" },
                    on: { click: _vm.authGoogle }
                  },
                  [_vm._v("Login")]
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mdl-layout__drawer" }, [
        _vm.user
          ? _c(
              "nav",
              { staticClass: "mdl-navigation" },
              [
                _vm._l(_vm.brunchSpots, function(spot, id) {
                  return [
                    _c("div", { staticClass: "spot-link-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass: "mdl-navigation__link",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.edit(id)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(spot.name) +
                              " (" +
                              _vm._s(spot.address) +
                              ")"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab",
                          on: {
                            click: function($event) {
                              _vm.infoWindow = id
                              _vm.persistentInfoWindow = true
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("place")
                          ])
                        ]
                      )
                    ])
                  ]
                })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "map-container mdl-layout__content" },
        [
          _c(
            "gmap-map",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                center: { lat: 0, lng: 0 },
                zoom: 3,
                options: { disableDefaultUI: true, clickableIcons: false }
              }
            },
            [
              _vm.user
                ? [
                    _vm._l(_vm.brunchSpots, function(spot, id) {
                      return spot.position && !spot.position.error
                        ? _c("gmap-marker", {
                            key: id,
                            attrs: { position: spot.position },
                            on: {
                              mouseover: function($event) {
                                _vm.infoWindow = _vm.persistentInfoWindow
                                  ? _vm.infoWindow
                                  : id
                              },
                              mouseout: function($event) {
                                _vm.infoWindow =
                                  !_vm.persistentInfoWindow &&
                                  _vm.infoWindow === id
                                    ? null
                                    : _vm.infoWindow
                              },
                              click: function($event) {
                                _vm.infoWindow = id
                                _vm.persistentInfoWindow = true
                              }
                            }
                          })
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._detail
                      ? _c(
                          "gmap-info-window",
                          {
                            attrs: {
                              options: {
                                pixelOffset: { width: 0, height: -35 },
                                maxWidth: 200
                              },
                              opened: _vm._detail != null,
                              position: _vm._detail.position
                            },
                            on: {
                              closeclick: function($event) {
                                _vm.persistentInfoWindow = false
                                _vm.infoWindow = null
                              }
                            }
                          },
                          [
                            _c("p", [_vm._v(_vm._s(_vm._detail.name))]),
                            _vm._v(" "),
                            _vm.imageIdToUrl(_vm._detail.logo)
                              ? _c("p", [
                                  _c("img", {
                                    staticClass: "brunch-logo",
                                    attrs: {
                                      src: _vm.imageIdToUrl(_vm._detail.logo),
                                      alt: ""
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(_vm._detail.address))]),
                            _vm._v(" "),
                            _c("p", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      _vm.edit(_vm.infoWindow)
                                      _vm.persistentInfoWindow = false
                                      _vm.infoWindow = null
                                    }
                                  }
                                },
                                [_vm._v("✍️ Edit")]
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.user
            ? _c(
                "button",
                {
                  directives: [{ name: "mdl", rawName: "v-mdl" }],
                  staticClass:
                    "add\n             mdl-button\n             mdl-js-button\n             mdl-button--fab\n             mdl-button--colored\n             mdl-js-ripple-effect",
                  on: {
                    click: function($event) {
                      _vm.dialog = "edit"
                    }
                  }
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("add")])]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.user && _vm.dialog === "edit"
        ? _c(
            "dialog",
            {
              directives: [
                { name: "mdl", rawName: "v-mdl" },
                { name: "dialog", rawName: "v-dialog" }
              ],
              staticClass: "mdl-dialog"
            },
            [
              _c(
                "div",
                { staticClass: "mdl-dialog__content" },
                [
                  _c(
                    "div",
                    {
                      directives: [{ name: "mdl", rawName: "v-mdl" }],
                      staticClass:
                        "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.brunchSpotForm.name,
                            expression: "brunchSpotForm.name"
                          }
                        ],
                        staticClass: "mdl-textfield__input",
                        attrs: { type: "text", id: "brunch-spot-form-name" },
                        domProps: { value: _vm.brunchSpotForm.name },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.saveBrunchSpot($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.brunchSpotForm,
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "mdl-textfield__label",
                          attrs: { for: "brunch-spot-form-name" }
                        },
                        [_vm._v("Name")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [{ name: "mdl", rawName: "v-mdl" }],
                      staticClass:
                        "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.brunchSpotForm.address,
                            expression: "brunchSpotForm.address"
                          }
                        ],
                        staticClass: "mdl-textfield__input",
                        attrs: { type: "text", id: "brunch-spot-form-address" },
                        domProps: { value: _vm.brunchSpotForm.address },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.saveBrunchSpot($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.brunchSpotForm,
                              "address",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "mdl-textfield__label",
                          attrs: { for: "brunch-spot-form-address" }
                        },
                        [_vm._v("Address")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.imageIdToUrl(_vm.brunchSpotForm.logo)
                    ? _c("p", [
                        _c("img", {
                          staticClass: "brunch-logo",
                          attrs: {
                            src: _vm.imageIdToUrl(_vm.brunchSpotForm.logo),
                            alt: ""
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { id: "brunch-spot-form-logo-input", type: "file" },
                    on: { change: _vm.logoSet }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    directives: [{ name: "mdl", rawName: "v-mdl" }],
                    ref: "logo-progress",
                    staticClass: "mdl-progress mdl-js-progress",
                    class: {
                      "mdl-progress__indeterminate":
                        this.logoUploader && this.logoProgress === 0
                    }
                  }),
                  _vm._v(" "),
                  _vm.brunchSpotForm.logo === ""
                    ? [
                        _c(
                          "label",
                          {
                            staticClass:
                              "mdl-button mdl-js-button mdl-button--raised mdl-button--colored block-button",
                            attrs: { for: "brunch-spot-form-logo-input" }
                          },
                          [_vm._v("\n          Set logo\n        ")]
                        )
                      ]
                    : [
                        _c(
                          "span",
                          {
                            staticClass:
                              "mdl-button mdl-js-button mdl-button--raised block-button",
                            on: { click: _vm.logoClear }
                          },
                          [_vm._v("\n          Clear logo\n        ")]
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mdl-dialog__actions" }, [
                _c(
                  "button",
                  {
                    directives: [{ name: "mdl", rawName: "v-mdl" }],
                    staticClass:
                      "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect",
                    attrs: {
                      type: "button",
                      disabled: _vm.logoUploader != null
                    },
                    on: { click: _vm.saveBrunchSpot }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.brunchSpotForm.id ? "Save" : "Add") +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.brunchSpotForm.id
                  ? _c(
                      "button",
                      {
                        staticClass: "mdl-button",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.deleteBrunchSpot(_vm.brunchSpotForm.id)
                          }
                        }
                      },
                      [_vm._v("Delete")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "mdl-button",
                    attrs: { type: "button" },
                    on: { click: _vm.resetEditForm }
                  },
                  [_vm._v("Close")]
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }